// src/utils/multipartApi.js
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem("token")}` });
const base = () => (import.meta.env.VITE_BACKEND_URL || "").replace(/\/+$/, "");

/* ============== Multipart ============== */
export async function initUpload({ bucket, prefix, name, type, size }) {
  const r = await fetch(`${base()}/api/buckets/${encodeURIComponent(bucket)}/multipart/init`, {
    method: "POST",
    headers: { ...auth(), "Content-Type": "application/json" },
    body: JSON.stringify({
      filename: `${prefix || ""}${name}`,
      contentType: type || "application/octet-stream",
      size,
    }),
  });
  if (!r.ok) throw new Error(`init ${r.status} ${await r.text().catch(() => "")}`);
  const data = await r.json();
  return {
    uploadId: data.uploadId,
    partSize: data.partSize,
    maxPartsPerBatch: data.maxPartsPerBatch || 1,
    mode: data.mode || "multipart",
  };
}

export async function getPartUrls(item, uploadId, from, to) {
  const r = await fetch(
    `${base()}/api/buckets/${encodeURIComponent(item.bucket)}/multipart/${encodeURIComponent(uploadId)}/parts` +
      `?key=${encodeURIComponent((item.prefix || "") + item.name)}&from=${from}&to=${to}`,
    { headers: auth() }
  );
  if (!r.ok) throw new Error(`parts ${r.status}`);
  const data = await r.json();
  return data.urls || [];
}

export async function completeUpload(item, uploadId, parts) {
  const r = await fetch(
    `${base()}/api/buckets/${encodeURIComponent(item.bucket)}/multipart/${encodeURIComponent(uploadId)}/complete`,
    {
      method: "POST",
      headers: { ...auth(), "Content-Type": "application/json" },
      body: JSON.stringify({ key: `${item.prefix || ""}${item.name}`, parts }),
    }
  );
  if (!r.ok) throw new Error(`complete ${r.status}`);
  return r.json().catch(() => ({}));
}

export async function abortUpload(item, uploadId) {
  await fetch(
    `${base()}/api/buckets/${encodeURIComponent(item.bucket)}/multipart/${encodeURIComponent(uploadId)}/abort` +
      `?key=${encodeURIComponent((item.prefix || "") + item.name)}`,
    { method: "DELETE", headers: auth() }
  );
}

/* ============== PUT direto (sem fallback legado) ============== */
export async function getPutUrl({ bucket, key, contentType }) {
  const r = await fetch(`${base()}/api/s3/put-url`, {
    method: "POST",
    headers: { ...auth(), "Content-Type": "application/json" },
    body: JSON.stringify({
      bucket,
      key,
      contentType: contentType || "application/octet-stream",
    }),
  });
  if (!r.ok) throw new Error(`put-url ${r.status} ${await r.text().catch(() => "")}`);
  return r.json(); // { url, headers? }
}
